
<div class="column-flex">
    <div class="form-label">
        <ng-container *ngIf="!isEditing">
            {{ 'graph.create.dialog.title' | translate }}
        </ng-container>
        <ng-container *ngIf="isEditing">
            {{ 'graph.edit.dialog.title' | translate }}
        </ng-container>
    </div>

    <div class="main-container">
        <form class="input-form" *ngIf="!isEditing">
            <div class="graph-name-label">
                {{ 'graph.create.dialog.type.label' | translate }}
            </div>
            <app-simple-dropdown
                style="height: 56px"
                [options]="TYPE_OPTIONS"
                [selectedOption]="selectedType"
                (onOptionSelected)="handleTypeChanged($event)">
            </app-simple-dropdown>
        </form>
        <form class="input-form">
            <div class="graph-name-label">
                {{ 'graph.create.dialog.title.label' | translate }}
            </div>
            <app-channel-text-input
                label="graph.create.dialog.title.legend"
                [value]="title"
                [inputError]="validationErrors?.title"
                [maxLength]="48"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [noLabel]="true"
            ></app-channel-text-input>
        </form>
    </div>

    <div class="buttons-container">
        <div class="cancel button" data-cy="graphs-modal-cancel-button" (click)="cancel()">
            {{ 'graph.create.dialog.button.cancel' | translate }}
        </div>
        <div
            *ngIf="!isEditing"
            class="create button"
            data-cy="graphs-modal-create-button"
            (click)="createGraph()"
            [ngClass]="{ button_disabled: isCreateDisabled }">
            {{ 'graph.create.dialog.button' | translate }}
        </div>
        <div
            *ngIf="isEditing"
            class="create button"
            data-cy="graphs-modal-save-button"
            (click)="createGraph()"
            [ngClass]="{ button_disabled: isEditDisabled }">
            {{ 'graph.edit.dialog.button' | translate }}
        </div>
    </div>
</div>


<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'graph.create.dialog.cancel.title'"
    [subLabel]="'graph.create.dialog.cancel.subLabel'"
    [discardLabel]="'graph.create.dialog.cancel.cancel'"
    [saveLabel]="'graph.create.dialog.cancel.save'"
    [allButtonsLeft]="true"
    [inverseColors]="true">
</app-confirmation-window>
